import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TokenInfo = {
  id?: string;
  aiid?: string;
  user_id?: string;
  telematics_device_id?: string | null;
  auth_token: string;
  type?: string;
  session_expires_on?: string;
  created_on?: string;
  additional_props?: Record<string, any>;
};

type AuthState = {
  token: TokenInfo | null;
};

const initialState: AuthState = {
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<TokenInfo>) => {
      state.token = action.payload;
    },
    clearAuth: (state) => {
      state.token = null;
    },
  },
});

export const { setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;
